// @TODO: unify with homepage search
export default function mainHeaderSearch(container) {
    const containerEl = document.querySelector(container);
    if (!containerEl) {
        return
    }

    const searchForm = containerEl.querySelectorAll('.search-form');
    const headerSearchInput = containerEl.querySelector('.search-input');
    const searchActiveClass = 'search_active';

    if ( !(searchForm && headerSearchInput) ) {
        return;
    }

    searchForm.forEach(form => {
        form.addEventListener("submit", function(e){
            e.preventDefault();

            const reportValidity = this.reportValidity ? this.reportValidity() : true;
            if (reportValidity) {
                window.location.href = form.action + form.s.value;
                return false;
            }
        });
    });

    const eheader = document.getElementById('e-header');

    containerEl.querySelector('.search-cta').addEventListener('click', function(e) {
        document.body.classList.add(searchActiveClass);
        eheader.classList.add('ov-hidden');

        setTimeout(function() {
            headerSearchInput.focus();
        }, 500);
    });

    const headerSearchClose = containerEl.querySelector('.closed_icon');

    if (!headerSearchClose) {
        return
    }

    headerSearchClose.addEventListener('click', function(e) {
        e.preventDefault();

        //clear on first click
        if (headerSearchInput.value) {
            headerSearchInput.value = '';
            return;
        }

        //close search when search input is empty
        document.body.classList.remove(searchActiveClass);
        setTimeout(function(){
            headerSearchInput.blur();
            eheader.classList.remove('ov-hidden');
        }, 500);
    });
}

